
import React, { useState } from 'react';

import { getToken, utc_local } from '../../helpers/Helper';
import { del } from '../../helpers/api_helper';
import { POST_REVIEWS_LIST, DELETE_REVIEWS } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom';
import useMounted from '../../hooks/useMounted';
import StarRating from '../../components/StarRating';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";


const ItemList = (props) => {
    const [Id, SetId] = useState(0);
    const [reviewInfo, SetReviewInfo] = useState(null);

    useMounted(() => {
        get_list()
    })

    const get_list = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [2, 7] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_REVIEWS_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "success": callback,
                        "error": function (xhr, textStatus, errorThrown) {
                            if (xhr.status === 401) {
                                window.location.href = '/logout';
                            }
                        }
                    });
                },
                "columns": [
                    { "data": "reviewId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                {utc_local(data.createdAt, 'DD MMM YYYY')}
                            </>, td)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                <img src={data.Image1} alt={data.designName} style={{ "maxWidth": "40px", "maxHeight": "40px" }} />
                            </>, td)
                        }
                    },
                    { "data": "designName" },
                    { "data": "userName" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                <a href={`/orders/view/${data.orderId}`} target="_blank" rel="noreferrer">{data.orderId}</a>
                            </>, td)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                <StarRating rating={data.rating} />
                            </>, td)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            ReactDOM.render(<>
                                <button className="btn btn-sm text-primary mr-2" onClick={() => { SetReviewInfo(data) }} data-bs-toggle="modal" data-bs-target="#ViewModal"><i className="bx bx-show align-middle"></i></button>
                                <button className="btn btn-sm text-danger" onClick={() => { SetId(data.reviewId); }} data-bs-toggle="modal" data-bs-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>
                            </>, td)
                        }
                    },
                ]
            });
        }
    }

    // remove role
    const remove_row = async () => {
        var res_data = await del(DELETE_REVIEWS + "?id=" + Id);
        if (res_data.status) {
            toast(res_data.message);
            get_list();
        } else {
            toast.error(res_data.message);
        }
    }


    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>Reviews</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                </div>
                            </div>
                            <hr />
                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Id</td>
                                            <td>Date</td>
                                            <td>Image</td>
                                            <td>Design Name</td>
                                            <td>User Name</td>
                                            <td>Order No</td>
                                            <td>Rating</td>
                                            <td>Action</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm Delete</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this record?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">Yes</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="ViewModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">View Review</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {reviewInfo && <>
                                <div className='row mb-3'>
                                    <div className='col-sm-4'>
                                        <img src={reviewInfo.Image1} alt={reviewInfo.designName} style={{ "maxWidth": "100px", "maxHeight": "100px" }} />
                                    </div>
                                    <div className='col-sm-8'>
                                        <p className='mb-2'>{reviewInfo.designName}</p>
                                        <p className='mb-2'>Order NO : {reviewInfo.orderId}</p>
                                        <p className='mb-2'>Name : {reviewInfo.userName}</p>
                                        <p className='mb-2'>{utc_local(reviewInfo.createdAt, 'DD MMM YYYY')}</p>
                                    </div>
                                </div>
                                <div className='row mb-3'>
                                    <div className='col-sm-12 mb-3'>
                                        <StarRating rating={reviewInfo.rating} />
                                    </div>
                                    <div className='col-sm-12'>
                                        <p>{reviewInfo.review}</p>
                                    </div>
                                </div>
                                <div className='row'>
                                    {reviewInfo.images && reviewInfo.images.length > 0 && <>
                                        {reviewInfo.images.map((image,key) => (
                                            <div className='col-sm-4 text-center mb-2' key={key}>
                                                <img src={image} alt="" style={{ "maxWidth": "100px", "maxHeight": "100px" }} />
                                            </div>
                                        ))}
                                    </>}
                                </div>
                            </>}
                        </div>
                        {/* <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ItemList;